import React, { Component } from "react";
import AnimatedNumber from "animated-number-react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
export default class Statistics extends Component {
  constructor(props) {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend
    );
    super(props);
    this.options = {
      responsive: true,
      plugins: {
        legend: {
          position: "bottom",
        },
        animation: {
          delayed: true,
        },
        title: {
          display: true,
          text: `${
            this.props.type.charAt(0).toUpperCase() + this.props.type.slice(1)
          } And Return`,
        },
      },
    };
  }

  render() {
    const statData = this.props.data;
    const typeData =
      this.props.type.charAt(0).toUpperCase() + this.props.type.slice(1);

    const data = {
      labels: statData ? statData.stat.map((x) => x.date) : [],
      datasets: [
        {
          label: typeData,
          data: statData ? statData.stat.map((x) => x.total) : [],

          borderColor: "#29AB87",
          backgroundColor: "rgba( 41, 171, 135,0.2)",
          fill: true,
          borderWidth: 1,
          lineTension: 0.5,
        },
        {
          label: `${typeData} Return`,
          data: statData ? statData.stat.map((x) => x.return) : [],
          borderColor: "#faa64b",
          backgroundColor: "rgba(250,166,75,0.2)",
          fill: true,
          borderWidth: 1,
          lineTension: 0.5,
        },
        {
          label: "Damage Return",
          data: statData ? statData.stat.map((x) => x.damage) : [],
          borderColor: "#ff5955",
          backgroundColor: "rgba(255,89,85,0.2)",
          fill: true,
          borderWidth: 1,
          lineTension: 0.5,
        },
      ],
    };
    const formatValue = (value) => `${Number(value).toFixed()}`;
    return (
      <div className="card">
        <h4 className="card-title">
          <strong>Statistics </strong>
          <small> {typeData}</small>
        </h4>
        <div className="card-body">
          <div className="m-2 row">
            <div className="col-8">
              <Line options={this.options} data={data} height={120} />
            </div>
            <div className="col-4">
              <div>
                <div className="divider"> Overall Analysis</div>
                <div className="card-body bl-3 border-success flexbox flex-justified">
                  <div>
                    <div className="fs-12 text-muted">{typeData}</div>
                    <div className="fs-18 text-purple">
                      <AnimatedNumber
                        value={statData.stat
                          .reduce(
                            (sum, data) => (sum += parseFloat(data.total)),
                            0
                          )
                          .toFixed(2)}
                        formatValue={formatValue}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="fs-12 text-muted">{typeData} Return</div>
                    <div className="fs-18 text-primary">
                      <AnimatedNumber
                        value={statData.stat.reduce(
                          (sum, data) => (sum += parseFloat(data.return)),
                          0
                        )}
                        formatValue={formatValue}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="fs-12 text-muted">Damage Return</div>
                    <div className="fs-18 text-danger">
                      <AnimatedNumber
                        value={statData.stat.reduce(
                          (sum, data) => (sum += parseFloat(data.damage)),
                          0
                        )}
                        formatValue={formatValue}
                      />
                    </div>
                  </div>
                </div>
                <div className="divider">
                  {" "}
                  Average Analysis {statData.days} Days
                </div>
                <div className="card-body br-3 border-info flexbox flex-justified">
                  <div>
                    <div className="fs-12 text-muted">{typeData}</div>
                    <div className="fs-18 text-purple">
                      <AnimatedNumber
                        value={statData.average.total}
                        formatValue={formatValue}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="fs-12 text-muted">{typeData} Return</div>
                    <div className="fs-18 text-primary">
                      <AnimatedNumber
                        value={statData.average.return}
                        formatValue={formatValue}
                      />{" "}
                      <small>
                        <AnimatedNumber
                          value={statData.average.perReturn}
                          formatValue={formatValue}
                        />{" "}
                        %
                      </small>
                    </div>
                  </div>
                  <div>
                    <div className="fs-12 text-muted">Damage Return</div>
                    <div className="fs-18 text-danger">
                      <AnimatedNumber
                        value={statData.average.damage}
                        formatValue={formatValue}
                      />{" "}
                      <small>
                        {" "}
                        <AnimatedNumber
                          value={statData.average.perDamage}
                          formatValue={formatValue}
                        />
                        %
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
